import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "semantic-ui-css/semantic.min.css";
import "./utils/animate.css";
import App from "./App";
// import registerServiceWorker from './registerServiceWorker';
import { unregister as unegisterServiceWorker } from "./registerServiceWorker";
import { Provider } from "mobx-react";
import store from "./Store";
import { HashRouter } from "react-router-dom";

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
  document.getElementById("root")
);

// registerServiceWorker();
unegisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js